import React, { useCallback } from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from './Catalog.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ConnectOptionProps<T extends string> {
  value: T;
  selected: T | undefined;
  title: string;
  description: string;
  disabled?: boolean;
  onSelect: (value: T) => void;
}

/** One radio-style choice in a sheet. */
function ConnectOptionInner<T extends string>({
  value,
  selected,
  title,
  description,
  disabled,
  onSelect,
}: ConnectOptionProps<T>) {
  const isOn = selected === value;
  const select = useCallback(() => onSelect(value), [onSelect, value]);

  return (
    <button
      type="button"
      role="radio"
      aria-checked={isOn}
      disabled={disabled}
      className={clsx(styles.option, isOn && styles.optionOn)}
      onClick={select}
    >
      <span className={clsx(styles.optionRadio, isOn && styles.optionRadioOn)} />
      <span>
        <b>{title}</b>
        <span>{description}</span>
      </span>
    </button>
  );
}

export const ConnectOption = TypedMemo(ConnectOptionInner) as typeof ConnectOptionInner;
